import { FC, useContext, useMemo } from 'react'
import { useQuery } from 'react-query'
import {
  createResponseContext,
  initialQueryResponse,
  QUERIES,
  stringifyRequestQuery,
  WithChildren,
} from '../../../../../../_metronic/helpers'
import { useQueryRequest } from './QueryRequestProvider'
import { AtendimentoPacienteList } from '../../../atendimento/core/_models'
import { getAtendimentosByPaciente } from '../../../atendimento/core/_requests'
import { useParams } from 'react-router-dom'
import { useModal } from '../../../../../components'

const QueryResponseContext = createResponseContext<AtendimentoPacienteList>(initialQueryResponse)
export const QueryResponseProvider: FC<WithChildren> = ({ children }) => {
  const { isOpen } = useModal()
  const { state } = useQueryRequest()

  const query = useMemo(() => stringifyRequestQuery(state), [state])

  const { pacienteId } = useParams<{ pacienteId: string }>()

  const {
    isFetching,
    isError,
    refetch,
    data: response,
  } = useQuery(
    [QUERIES.PACIENTE_HISTORICO_LIST, pacienteId, query, isOpen],
    () => getAtendimentosByPaciente(Number(pacienteId), query),
    { cacheTime: 0, keepPreviousData: true, refetchOnWindowFocus: false, enabled: !isOpen }
  )

  return (
    <QueryResponseContext.Provider
      value={{ isLoading: isFetching, isError, refetch, response, query }}
    >
      {children}
    </QueryResponseContext.Provider>
  )
}

export const useQueryResponse = () => useContext(QueryResponseContext)
